import decodeSymbols from '@framework/data-helpers/string/decodeSymbols';
import { IProfile } from '@/openMarket/domain/vo/IProfile';

export const getDecodedProfile = (profile: IProfile) => ({
  ...profile,
  name: decodeSymbols(profile.name),
  headerDescription: decodeSymbols(profile.headerDescription),
});
